import style from './login.module.css'
import logo from "../../../img/logo.png"
import FormLogin from './FormLogin'
import Button from '../../layout/Button/Button'
import { useNavigate } from 'react-router-dom'
export default function Login(){

    const navigate = useNavigate()
    return(
        <div className={style.login_container}>
            <div className={style.login_card}>
                
                {/* A sua imagem original, agora com classe de estilo */}
                <img 
                    src={logo}
                    alt="Logo Chamada EBD"
                    className={style.logo_img}
                />
                
                <h1 className={style.login_title}>EBD Chamada</h1>
                <p className={style.login_subtitle}>Assece sua conta para gerir as suas turmas e alunos.</p>

                <FormLogin />
                <Button style={{marginTop:'12px', width:'100%'}} variant='outline' onClick={()=>navigate('/cadastro')}>Cadastrar</Button>
            </div>
        </div>
    )
}